<template>
	<div class="field field--checkbox">
		<div class="field__label-wrap">
			<label-field class="field__label" :value="label"></label-field>
			<slot name="post-label"></slot>
		</div>
		<div class="field__element-group">
			<slot name="_internal"></slot>
			<slot name="manual"></slot>
<!--
			<div class="field__element-wrap" v-for="(option, index) in allOptions">
				<input ref="fieldElement" class="field__element" :id="`input-${id}-${index}`" :name="name" type="checkbox" :value="option.value" :required="option.required" :disabled="option.disabled" />
				<label-field class="field__sub-label" :for="`input-${id}-${index}`">{{option.label}}</label-field>
			</div>
-->
		</div>
	</div>
</template>

<script>
import {some, findIndex} from 'lodash'

import LabelField from './LabelField'

export default {
	name: 'CheckboxField',
	components: {
		LabelField
	},
	props: {
		label: String,
		name: String,
		options: Array,
		value: Array,
		disabled: String
	},
	data () {
		return {
			allOptions: null,
			selectedItems: this.value || []
		}
	},
	computed: {
		id: function() {
			return this._uid;
		},
	},
	created: function()
	{
		this.selfExecutedUpdate = false;
		this.formatDefaultSlots();
	},
	mounted: function()
	{
	},
	updated: function()
	{
		if(!this.selfExecutedUpdate)
		{
			this.selectedItems = this.value || []
			this.selfExecutedUpdate = true;
			this.formatDefaultSlots();
			this.$forceUpdate();
		}
		else
		{
			this.selfExecutedUpdate = false;
		}
	},
	methods: {
		formatDefaultSlots: function()
		{
			// Initialise
			var self = this;

			const createElement = self.$createElement;
			const options = self.options || [];
			let slots = self.$slots.default;
			let count = 0;
			self.$slots._internal = [];
			self.allOptions = [];


			// Clean up slots
			if(slots && slots.length)
			{
				// We only want <option value="{value}">{label}</option> nodes
				slots = slots.filter(slot => slot.tag == "option" && slot.data && ((slot.data.attrs && slot.data.attrs.value) || (slot.data.domProps && slot.data.domProps.value) )).map((option, i) => {

					let value = option.data.attrs && option.data.attrs.value ? option.data.attrs.value : option.data.domProps.value;

					this.$slots._internal.push(
						createElement('div', {
							'class': 'field__element-group-item'
						}, [
							createElement('div', {
								'class': 'field__element-wrap'
							}, [
								createElement('input', {
									ref: 'fieldElement',
									refInFor: true,
									class: 'field__element',
									attrs: {
										id: `input-${this.id}-${count}`,
										name: this.name,
										type: 'checkbox',
										required: option.data.attrs ? option.data.attrs.required : null,
										disabled: option.data.attrs ? option.data.attrs.disabled : null,
										checked: self.selectedItems.includes(value) || some(self.selectedItems, value)
									},
									domProps: {
										value: value
									},
									on: {
										change: function (event) {
											self.toggleChecked(value);
											self.$emit('input', self.selectedItems);
										}
									}
								}),
								createElement(LabelField, {
									class: 'field__sub-label',
									attrs: {
										for: `input-${this.id}-${count}`,
									}
								}, [
									createElement('span', {
									}, [
										option.children
									])
								])
							]),
							this.$slots.postElementWrap,
						])
					);

					self.allOptions.push(value);
					count++;
				})
			}

			// Now add props.options
			options.map((option, i) => {

				this.$slots._internal.push(
					createElement('div', {
						'class': 'field__element-group-item'
					}, [
						createElement('div', {
							'class': 'field__element-wrap'
						}, [
							createElement('input', {
								ref: 'fieldElement',
								refInFor: true,
								class: 'field__element',
								attrs: {
									id: `input-${this.id}-${count}`,
									name: this.name,
									type: 'checkbox',
									required: option.required,
									disabled: option.disabled,
									checked: self.selectedItems.includes(option.value) || some(self.selectedItems, option.value)
								},
								domProps: {
									value: option.value
								},
								on: {
									change: function (event) {
										self.toggleChecked(event.target.value);
										self.$emit('input', self.selectedItems);
									}
								}
							}),
							createElement(LabelField, {
								class: 'field__sub-label',
								attrs: {
									for: `input-${this.id}-${count}`,
								},
								props: {
									value: '<span>' + option.label + '</span>'
								}
							})
						]),
						this.$slots.postElementWrap,
					])
				);

				self.allOptions.push(option.value);
				count++;
			});
		},
		toggleChecked: function(value)
		{
			var self= this;
			// Different 'exists' checks to account for the typeof value
			if(self.selectedItems.includes(value) || some(self.selectedItems, value))
			{
				// Different 'index' checks to account for the typeof value
				var index = self.selectedItems.indexOf(value);
				index = index > -1 ? index : findIndex(self.selectedItems, value);
				if (index > -1) {
					self.selectedItems.splice(index, 1);
				}
			}
			else
			{
				self.selectedItems.push(value);
			}
		},
		selectAll: function()
		{
			var self = this;

			self.selectedItems = [];
			self.allOptions.map((option, i) => {
				self.selectedItems.push(option);
			});
			self.$emit('input', self.selectedItems);
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".field";
	#{$c}
	{
		&--checkbox
		{
			#{$c}__sub-label
			{
				&::before, > *
				{
					vertical-align: middle;
				}

				> *
				{
					color: palette(grey);
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/atoms/CheckboxField.vue